<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="گزارش سررسید اقساط بر اساس تاریخ" color="accent">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="3">
						</v-col>
						<v-col cols="12" md="6">
							<date-navigator v-model="dateRange">
								<div class="text-center">
									<v-btn color="primary" small dark class="mx-1" @click="loadData">
										دریافت اطلاعات
									</v-btn>
								</div>
							</date-navigator>
						</v-col>
						<v-col cols="12" md="3" class="d-flex align-center justify-end">
							<export-excel :items="items" :headers="headers" :fileName="excelFileName">
							</export-excel>
							<v-btn color="primary" small dark class="mx-1" @click="routeToPath('/admin/installmentsimport')">
								<v-icon dark>
									mdi-package-up
								</v-icon>
								ورود اقساط از فایل اکسل
							</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<span class="ml-2">فیلترها:</span>
							<v-btn-toggle multiple v-model="filter" dense tile outlined color="purple mr-2">
								<v-btn value="Paid" small>
									پرداخت شده ها
									<v-badge color="success" :content="items.filter(x => x.loanPayment.amount > 0).length || '0'" inline>
									</v-badge>
								</v-btn>
								<v-btn value="NoPaid" small>
									پرداخت نشده ها
									<v-badge color="error" :content="items.filter(x => x.loanPayment.amount == 0).length || '0'" inline></v-badge>
								</v-btn>
							</v-btn-toggle>
						</v-col>
					</v-row>
					<v-row style="background-color: #eee;border: 1px solid #ddd;text-align: center;">
						<v-col cols="6" md="4" class="text-center">
							<div>تعداد:</div>
							<div class="grey--text">{{ count }}</div>
						</v-col>
						<v-col cols="6" md="4" class="text-center">
							<div>مجموع اقساط:</div>
							<div class="grey--text">{{ installmentsTotal.toString().toPriceFormat() }}</div>
						</v-col>
						<v-col cols="6" md="4" class="text-center">
							<div>مجموع واریزی ها:</div>
							<div class="grey--text">{{ paymentsTotal.toString().toPriceFormat() }}</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="filteredItems" :loading="loading" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td class="text-center">
											<div @click="manageLoans(row.item)" style="cursor:pointer">
												<div>{{ row.item.userLoan.memberModel.fullName }}</div>
												<div>{{ row.item.userLoan.memberModel.mobile }}</div>
												<div class="grey--text text--small"><small>کد ملی: {{ row.item.userLoan.memberModel.nationalCode }}</small></div>
											</div>
										</td>
										<td class="text-center">
											<div @click="manageLoans(row.item)" style="cursor:pointer">
												<div class="">شماره پرونده: {{ row.item.userLoan.code }}</div>
												<div class="grey--text text-small"><small>{{ row.item.userLoan.loanModel.title }}</small></div>
											</div>
										</td>
										<td class="text-center">
											{{ row.item.userLoan.installment.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.loanPayment.amount === 0 && row.item.userLoan.isCheckouted ? 'تسویه شده' : row.item.loanPayment.amount.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ `${row.item.loanPayment.targetMonth_Persian.date}` }}
										</td>
										<td class="text-center">
											{{ `${row.item.loanPayment.saveDate_Persian.date}` }}
										</td>
										<td class="text-center">
											{{ paymentInfo(row.item.loanPayment) }}
										</td>
										<td class="text-center">
											<div :class="row.item.loanPayment.delayDay > 0 ? 'red--text' : 'success--text'" v-if="row.item.loanPayment.delayDay != 0">
												<div>{{ row.item.loanPayment.delayDay > 0 ? 'دیرکرد' : 'زودکرد' }}: {{ Math.abs(row.item.loanPayment.delayDay) }} روز</div>
												<div>{{ row.item.loanPayment.delayPrice.toString().toPriceFormat() }}</div>
											</div>
											<div v-else-if="row.item.loanPayment.amount !== 0" class="grey--text">
												بدون تاخیر
											</div>
										</td>
										<td class="">
											{{ row.item.loanPayment.description }}
										</td>
										<td class="">
											<app-sms-detail :data="row.item.loanPayment.appSmsList" :entityId="row.item.loanPayment.id" />
										</td>
										<td class="">
											{{ row.item.userLoan.agentModel ? row.item.userLoan.agentModel.businessName : '' }}
										</td>
										<td class="text-center">
											<v-btn class="mx-2" fab dark small color="secondary" @click="edit(row.item)">
												<v-icon dark>
													mdi-square-edit-outline
												</v-icon>
											</v-btn>
											<v-btn class="mx-2" fab dark small color="pink" @click="remove(row.item)">
												<v-icon dark>
													mdi-trash-can-outline
												</v-icon>
											</v-btn>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogModifyLoanPayment" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ویرایش قسط</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyLoanPayment = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-loan-payment ref="modifyLoanPayment" v-if="dialogModifyLoanPayment" :data="selectedLoanPayment" @callbck="callbck_loanPayment" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import router from '@/router'

export default {
	name: 'InstallmentsByMonth',
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		'date-navigator': () => import('@/components/DateNavigator'),
		'manage-loan': () => import('@/views/admin/ManageLoan'),
		'date-picker': VuePersianDatetimePicker,
		'modify-loan-payment': () => import('@/views/admin/ModifyLoanPayment'),
		'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
	},
	data() {
		return {
			selectedLoanPayment: null,
			selectedMember: null,
			dialogModifyLoanPayment: false,
			dialogLoansManager: false,
			errorMessages: '',
			startDateValidatioin: '',
			endDateValidatioin: '',
			search: '',
			loading: false,
			headers: [
				{
					text: 'مشتری',
					align: 'center',
					sortable: true,
					value: 'userLoan.memberModel.fullName',
				}, {
					text: 'موبایل',
					align: ' d-none',
					sortable: true,
					value: 'userLoan.memberModel.mobile',
				}, {
					text: 'کد ملی',
					align: ' d-none',
					sortable: true,
					value: 'userLoan.memberModel.nationalCode',
				}, {
					text: 'نوع وام',
					align: 'center d-none',
					sortable: true,
					value: 'userLoan.loanModel.title',
				}, {
					text: 'اطلاعات وام',
					align: 'center',
					sortable: true,
					width: 150,
					value: 'userLoan.code',
				}, {
					text: 'مبلغ قسط',
					align: 'start',
					sortable: true,
					value: 'userLoan.installment',
				}, {
					text: 'مبلغ واریزی',
					align: 'center',
					sortable: true,
					value: 'loanPayment.amount',
				}, {
					text: 'تاریخ سررسید',
					align: 'center',
					sortable: true,
					value: 'loanPayment.targetMonth',
					excel_value: 'loanPayment.targetMonth_Persian.date',
				}, {
					text: 'تاریخ واریز',
					align: 'center',
					sortable: true,
					value: 'loanPayment.saveDate',
					excel_value: 'loanPayment.saveDate_Persian.date',
				}, {
					text: 'نحوه پرداخت',
					align: 'center',
					sortable: true,
					value: 'loanPayment.paymentMethod',
					excel_value: 'loanPayment',
					excel_callback: (value) => {
						return this.paymentInfo(value)
					}
				}, {
					text: 'دیرکرد/زودکرد',
					align: 'center',
					sortable: true,
					value: 'loanPayment.delayDay',
					excel_value: 'loanPayment',
					excel_callback: (value) => {
						let text = ''
						if (value.delayDay === 0)
							text = 'بدون تاخیر'
						else {
							text = `${value.delayDay > 0 ? 'دیرکرد' : 'زودکرد'}: ${Math.abs(value.delayDay)} روز`
						}
						return text
					}
				}, {
					text: 'مبلغ دیرکرد/زودکرد',
					align: ' d-none',
					sortable: true,
					value: 'loanPayment.delayPrice',
				}, {
					text: 'توضیحات',
					align: 'center',
					sortable: true,
					value: 'loanPayment.description',
				}, {
					text: 'پیامک ها',
					align: 'center',
					sortable: false,
					width: 150,
					value: 'loanPayment.appSmsList',
				}, {
					text: 'نماینده',
					align: 'center',
					sortable: false,
					value: 'userLoan.agentModel.businessName',
				}, {
					text: 'عملیات',
					align: 'center',
					sortable: false,
					width: 150,
				}

			],
			items: [],
			filter: [],
			dateRange: { start: '', end: '' }
		}
	},
	computed: {
		excelFileName() {
			let name = 'گزارش سررسید اقساط'
			if (this.dateRange.start)
				name += ' از ' + this.dateRange.start.toString().split('T')[0]
			if (this.dateRange.end)
				name += ' تا ' + this.dateRange.end.toString().split('T')[0]
			name += '.xls'
			return name
		},
		filteredItems() {
			if (!(this.filter || []).length)
				return this.items
			let clonedItems = []
			if (this.filter.indexOf('Paid') > -1)
				clonedItems.push(...this.items.filter(x => x.loanPayment.amount > 0))
			if (this.filter.indexOf('NoPaid') > -1)
				clonedItems.push(...this.items.filter(x => x.loanPayment.amount === 0))
			return clonedItems
		},
		count() {
			return this.filteredItems.length
		},
		installmentsTotal() {
			return this.filteredItems.reduce((accumulator, current) => accumulator + current.userLoan.installment, 0)
		},
		paymentsTotal() {
			return this.filteredItems.reduce((accumulator, current) => accumulator + current.loanPayment.amount, 0)
		},
	},
	mounted() {
	},
	methods: {
		manageLoans(item) {
			this.selectedMember = { id: item.userLoan.memberModel.id, fullName: item.userLoan.memberModel.fullName, nationalCode: item.userLoan.memberModel.nationalCode, mobile: item.userLoan.memberModel.mobile }
			this.dialogLoansManager = true
			this.$nextTick(() => {
				this.$refs.manageLoan.loadData()
			})
		},
		edit(item) {
			this.selectedLoanPayment = { id: item.loanPayment.id, userLoanModel: item.userLoan }
			this.dialogModifyLoanPayment = true
		},
		async remove(item) {
			if (!item) { return }

			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از حذف این آیتم مطمئن هستید؟',
			)) {
				api.post('admin/loanpayment/delete/' + item.loanPayment.id)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadData()
						})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
		callbck_loanPayment(result) {
			this.dialogModifyLoanPayment = false
			if (result) {
				this.loadData()
			}
		},
		paymentInfo(paymentRow) {
			let paymentMethods = [
				{ id: 1, title: 'نقدی' },
				{ id: 2, title: 'واریز' },
				{ id: 3, title: 'طلا' },
				{ id: 4, title: 'آنلاین' },
				{ id: 5, title: 'کارتخوان' },
			]
			let payment = paymentMethods.find(x => x.id == paymentRow.paymentMethod)

			if (!payment)
				return ''

			return `پرداخت: ${payment.id == 3 ? paymentRow.goldWeight + ' گرم ' : ''}${payment.title}`
		},
		loadData() {
			this.loading = true
			api.get('admin/report/InstallmentsByMonth/?start=' + this.dateRange.start + '&end=' + this.dateRange.end, {})
				.then(response => {
					this.items = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loading = false })
		},
		routeToPath(path) {
			router.push({ path: path }).catch(() => { })
		}
	},
}
</script>
<style></style>
